module.exports = __webpack_public_path__ + "img/register-bg.9f51e290.png";